import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Globals } from "app/globals";

@Injectable()
export class AssessmentRefreshGuardService implements CanActivate {

    constructor(private _Globals: Globals, private router: Router) { }

    // 'app/assessment' is only reached when the page is refreshed while taking an assessment
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): UrlTree {
        if (this._Globals.getMode() === 'Rater') {
            return this.router.parseUrl('/app/rater_assessments');
        }

        return this.router.parseUrl('/app/client_assessments');
    }


}
